import React, { Component } from 'react';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import { change, Field, reduxForm } from 'redux-form';

import {renderToggleButton} from '../../../../components/reduxFields';
import PatientInfo from '../../patient_info';
import { CommonButton } from '../../../../components/buttons';
import { showWarningMessage } from '../../../../actions/utilAction';
import AuthorizationModal from './authorization_modal';
import { showFormatedDate, base64Decode, alertConfirmation } from '../../../../actions/utilAction';
import { deletePatientAuthorizationData, getPatientAuthorizationByID, getPatientInsuranceForAuthorizationById, UpdatePatientAuthorizationData } from '../../actions/PatientActions';

class Authorization extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,      
      patientId: props.match.params.id ? base64Decode(props.match.params.id) : null,
      authId: null,
      authorizations: [],
      authorizationProcedures: [],
      authorizationProcedureCPTs: [],
      includedData: [],
      InsuranceCompanyList: [],
      activeAuthorizationToggleValues: [],   
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  loadData() {
    // let searchObj = {
    //   filters: { PatientId: patient_id ? patient_id : this.state.patientId },
    //   includes: 'include=authorizationprocedures,insurancecompanies',
    // };
    let patientID = this.state.patientId;
    this.props.getPatientAuthorizationByID(patientID);
  }
  componentWillMount() {
    if (this.state.patientId) {
      this.props.getPatientInsuranceForAuthorizationById(this.state.patientId, '');
      this.loadData();
    }
  }

  _updatedList(list){
    let updatePatientInsurancelist = list;
    if(list && list.length){
      updatePatientInsurancelist = list.map((l)=>{
        let date = showFormatedDate(moment(l.cardIssueDate).format('MM-DD-YYYY'));
        let value =  `${l.value}-${date}`;
        if(!l.cardIssueDate){
          value =  `${l.value}`;
        }

        return {
          ...l,
          value
        }
      })
    }
    return updatePatientInsurancelist;
  }
  
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.authorizationList && this.props.authorizationList !== nextProps.authorizationList) {
      let authData = nextProps.authorizationList.data;
      this.setState({
        authorizations: authData.Authorization,
        authorizationProcedures: authData.AuthorizationProcedure,
        authorizationProcedureCPTs: authData.AuthorizationProceduresCPT,
      });
    }
    if (nextProps.saved_patientAuthorization && this.props.saved_patientAuthorization !== nextProps.saved_patientAuthorization) {
      this.loadData();
    }
    if (nextProps.deleted_patientAuthorization && this.props.deleted_patientAuthorization !== nextProps.deleted_patientAuthorization) {
      this.loadData();
    }
    if (nextProps.patient_insurance && nextProps.patient_insurance !== this.props.patient_insurance) {
      let insuranceCompanies = nextProps.patient_insurance.data;
      this.setState({ InsuranceCompanyList: insuranceCompanies || [] });
    }

    let authListArray = (nextProps.authorizationList && nextProps.authorizationList.data.Authorization) || [];
    let activeAuthorizationToggleValues = new Array(authListArray.length).fill({});
    let index = 0;
    authListArray.map((obj) => {
      if (activeAuthorizationToggleValues.indexOf(obj) === -1) {
        activeAuthorizationToggleValues.splice(index, 1, obj);
        index = index + 1;
      }
      return activeAuthorizationToggleValues;
    });

    this.setState({
      activeAuthorizationToggleValues,
    });

  };
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleOpen = () => {
    Alert.closeAll();
    // if (!(this.props.patient_insurance 
    //     && this.props.patient_insurance.data
    //     && this.props.patient_insurance.data.length
    //   )) {
    //   showWarningMessage('Client is not assigned with any insurance company.', 5000);
    //   return false;
    // }
    this.setState({ open: true, authId: null });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleEditClick=(e, Obj) => {
    Alert.closeAll();
    // let authData = {
    //   'StartDate': Obj.startDate,
    //   'EndDate': Obj.endDate,
    //   'AuthorizationTitle': Obj.authorizationTitle,
    //   'AuthorizationNumber': Obj.authorizationNumber,
    //   'InsuranceCompanyID': Obj.patientInsuranceId,
    //   'Notes': Obj.notes,
    //   'Procedure': Obj.Procedure,
    //   'PayerId': Obj.payerId,
    // };
    this.setState({ open: true, authId: Obj.authorizationId });
  };
  handleAlertClick=(event, auth_id) => {
    this.props.deletePatientAuthorizationData(auth_id);
    Alert.closeAll();
  };
  handleDeleteClick=(event, obj) => {
    alertConfirmation('Are you sure you want to delete authorization details?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.authorizationId,
      },
    });
  };
  handleExpandRow=(rowid) => {
    let display = this.refs['auth' + rowid].style.display;
    if (display === 'none') {
      this.refs['auth' + rowid].style.display = 'table-row';
      this.refs['authClass' + rowid].className = 'fa fa-minus';
    } else {
      this.refs['auth' + rowid].style.display = 'none';
      this.refs['authClass' + rowid].className = 'fa fa-ellipsis-h';
    }
  };
  extractArrayDataFromObject(type, myArray, id) {
    let returnArr = [];
    if (myArray !== undefined) {
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].type === type && myArray[i].attributes.AuthorizationId === id) {
          returnArr.push(myArray[i].attributes);
        }
      }
    }
    return returnArr;
  }
  extractMasterDataFromObject(myArray, id) {
    let returnobj = {};
    if (myArray !== undefined) {
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].id === id) {
          return myArray[i];
        }
      }
    }
    return returnobj;
  }
  extractCPTArrayDataFromObject(myArray, AuthProcedureCPTLink) {
    let returnArr = [];
    if (myArray && AuthProcedureCPTLink) {
      AuthProcedureCPTLink.map((obj, i) => {
        let data = myArray.find((item) => item.id === obj.cptid);
        if (data) {
          returnArr.push(data);
        }
        return returnArr;
      });
    }
    return returnArr;
  }


  onActiveAuthorizationToggle = (e, index, Obj) => {
    alertConfirmation('Are you sure you want to remove this authorization from dashboard?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAuthorizationTargetAlertClick,
        // value: e.target.value,
        id: index,
        userID: Obj.authorizationId,
      },
    });    
  };

  handleAuthorizationTargetAlertClick = (event, index, authID) => {
    let activeAuthorizationToggleValues = this.state.activeAuthorizationToggleValues;
    activeAuthorizationToggleValues[index].isRemoveFromDashboard = !activeAuthorizationToggleValues[index].isRemoveFromDashboard;
    this.setState({ activeAuthorizationToggleValues });
    this.props.UpdatePatientAuthorizationData(authID,this.state.activeAuthorizationToggleValues[index].isRemoveFromDashboard);
    Alert.closeAll();
  };

  renderExpiredData(isExpired) {
    let authDataEmpty = true;
    let exprireDataEmpty = true;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
    });
    const tableClass1 = classNames({
      'table': true,
      'middletable': true,
    });
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    this.state.authorizations.map((Obj, index) => {
      let data = Obj;
      if (isExpired) {
        if (data.isExpired) {
          exprireDataEmpty = false ;
        }
      } else {
        if (!data.isExpired) {
          authDataEmpty = false ;
        }
      }
      return { exprireDataEmpty, authDataEmpty };
    });
    if ((isExpired && exprireDataEmpty) || (!isExpired && authDataEmpty)) {
      return (<div className="familydl text-center no-record">No record found.</div>);
    }
    return (
      <div className="table-responsive">
        <table className={tableClass}>
          
          <thead>
            <tr>
              <th width="5%">{/* <span style={{ 'visibility': 'hidden' }}>blank</span>*/}</th>
              <th width="15%">Auth #</th>
              <th width="20%">Title</th>
              <th width="20%">Insurance Company</th>
              <th width="10%">Start Date</th>
              <th width="10%">End Date</th>
              <th width="10%">Hide From Dashboard</th>
              {(this.props.updatePermission || this.props.deletePermission) ?
                <th width="10%">Action</th>
                : <th width="10%"></th>
              }
            </tr>
          </thead>
          <tbody>
            { this.state.authorizations.map((Obj, index) => {
              let data = Obj;
              if (isExpired) {
                if (!data.isExpired) {
                  return (<tr key ={index}><td></td></tr>);
                }
              } else {
                if (data.isExpired) {
                  return (<tr key ={index}><td></td></tr>);
                }
              }
              // let Procedure = this.extractArrayDataFromObject('authorization-procedures', this.state.includedData, Obj.id);
              let Procedure = this.state.authorizationProcedures.filter((obj) => obj.authorizationId === data.authorizationId);
              let cptID = [];
              let cptData = [];
              let attachedModifiers = null;
              Procedure = Procedure.map((data, i) => {
                let cpt = this.state.authorizationProcedureCPTs.filter((obj) => obj.authorizationProcedureId === data.authorizationProcedureId);
                let totalBlockedUnits = 0;
                let totalRemainUnits = 0;
                if (cpt) {
                  attachedModifiers = (cpt && cpt.length === 1) ? cpt[0].attachedModifiers : null;
                  cptData = cpt.map((obj, i) => obj.serviceCode);
                  cptID = cpt.map((obj, i) => obj.serviceCodeId);
                  cpt.map((obj) => {
                    totalBlockedUnits = totalBlockedUnits + obj.blockedUnit;
                    return totalBlockedUnits;
                  });
                }
                
                let actualAuthProcedureUnitConsumed = 0;
                
                let unitTypeName = '';
                let unitDuration = '0.00'
                cpt.map((obj) => {             
                  
                  unitTypeName = obj.unitTypeName;
                  unitDuration = obj.unitDuration;
                  actualAuthProcedureUnitConsumed = obj.actualAuthProcedureUnitConsumed;

                  totalRemainUnits = obj.actualAuthProcedureAllowedUnit - (obj.actualAuthProcedureUnitConsumed + totalBlockedUnits);
                });
                // organise the Auth procedures and cpt codes to display listing ...
                return { 
                  'AuthProceduresCPT': cpt,
                  'CPTCode': cptData,
                  'CPTCodeID': cptID,
                  'attachedModifiers': attachedModifiers,
                  'Unit': data.totalUnit,
                  'TypeID': data.typeId,
                  'TypeName': data.globalCodeName,
                  'ID': data.authorizationProcedureId,
                  'UnitBlocked': totalBlockedUnits,
                  'UnitConsumed': actualAuthProcedureUnitConsumed,
                  'UnitRemain':  (totalRemainUnits).toFixed(2),
                  'UnitInHours':  (data.totalUnit > 0 ? unitTypeName === 'Minute(s)' ? ((data.totalUnit * unitDuration)/60).toFixed(2) + ' Hour(s)' : unitTypeName === 'Hour(s)'  ? (data.totalUnit).toFixed(2) + ' Hour(s)' : ' ' + unitTypeName : '0 Hour'),
                  'UnitBlockedInHours': (totalBlockedUnits > 0 ? unitTypeName === 'Minute(s)' ? ((totalBlockedUnits * unitDuration)/60).toFixed(2) + ' Hour(s)' : unitTypeName === 'Hour(s)'  ? (totalBlockedUnits).toFixed(2) + ' Hour(s)' : ' ' + unitTypeName : '0 Hour'),
                  'UnitConsumedInHours':  (actualAuthProcedureUnitConsumed > 0 ? unitTypeName === 'Minute(s)' ? ((actualAuthProcedureUnitConsumed * unitDuration)/60).toFixed(2) + ' Hour(s)' : unitTypeName === 'Hour(s)'  ? (actualAuthProcedureUnitConsumed).toFixed(2) + ' Hour(s)' : ' ' + unitTypeName : '0 Hour'),
                  'UnitRemainInHours':  (totalRemainUnits > 0 ? unitTypeName === 'Minute(s)' ? ((totalRemainUnits * unitDuration)/60).toFixed(2) + ' Hour(s)' : unitTypeName === 'Hour(s)'  ? (totalRemainUnits).toFixed(2) + ' Hour(s)' : ' ' + unitTypeName : '0 Hour'),
                };
              });

              Obj.Procedure = Procedure;
              let InsCompanyName = data.payerName;
              return (
                <tr key={Obj.authorizationId}>
                  <td colSpan="12">
                    <table className={tableClass1}>
                      <tbody>
                        <tr>
                          <td width="5%">
                            <button onClick={(e) => this.handleExpandRow(Obj.authorizationId)} type="button" className="morebtn">
                              <i ref={'authClass' + Obj.authorizationId} className="fa fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                          </td>
                          <td width="15%">{data.authorizationNumber}</td>
                          <td width="20%">{data.authorizationTitle}</td>
                          <td width="20%">{InsCompanyName}</td>
                          <td width="10%">{showFormatedDate(data.startDate)}</td>
                          <td width="10%">{showFormatedDate(data.endDate)}</td>
                          <td width="10%">
                            <Field className="no_margin"
                              name="authorization_active_status"
                              toggled={this.state.activeAuthorizationToggleValues[index] && this.state.activeAuthorizationToggleValues[index].isRemoveFromDashboard ? this.state.activeAuthorizationToggleValues[index].isRemoveFromDashboard : false}
                              component={renderToggleButton}
                              onChange={(e) => this.onActiveAuthorizationToggle(e, index, Obj)}
                            />
                          </td>
                          {(this.props.updatePermission || this.props.deletePermission) ?
                            <td width="10%">
                              {/* {(!isExpired) && this.props.updatePermission ? */}
                              {this.props.updatePermission ?
                                <button onClick={(e) => this.handleEditClick(e, Obj)} title="Edit" type="button" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                : null
                              }
                              {
                                this.props.deletePermission ?
                                  <button onClick={(e) => this.handleDeleteClick(e, Obj)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                  : null
                              }
                            </td>
                            : <td width="10%"></td>
                          }
                        </tr>
                        <tr className="nohover" ref={'auth' + Obj.authorizationId} style={{ 'display': 'none' }}>
                          <td colSpan="12">
                            <table className={tableClass2 }>
                              <thead>
                                <tr>
                                  <th width="5%">{/* <span style={{ 'visibility': 'hidden' }}>blank</span>*/}</th>
                                  <th width="13%">Service Codes</th>
                                  <th width="13%">Modifiers</th>
                                  <th width="19%">Units Approved</th>
                                  <th width="15%">Units Completed</th>
                                  <th width="15%">Units Scheduled</th>
                                  <th width="15%">Units Remaining</th>
                                  <th width="5%">&nbsp;</th>
                                </tr>
                              </thead>
                              <tbody>
                                { Procedure.map((data, i) => {
                                  // let type = this.extractMasterDataFromObject(this.state.patientMasterData.masterAuthorizedProcedure, data.TypeID);
                                  return (
                                    <tr key={i}>
                                      <td width="5%">&nbsp;</td>
                                      <td width="13%">{data.CPTCode.join(', ')}</td>
                                      <td width="13%">{data.attachedModifiers || '-'}</td>
                                      <td width="19%">{`${data.Unit}${data.TypeName ? ' Per ' + data.TypeName : ''}`} <br/><strong>{data.UnitInHours}</strong></td>
                                      <td width="15%">{data.UnitConsumed} <br/><strong>{data.UnitConsumedInHours}</strong></td>
                                      <td width="15%">{data.UnitBlocked} <br/><strong>{data.UnitBlockedInHours}</strong></td>
                                      <td width="15%">{data.UnitRemain} <br/><strong>{data.UnitRemainInHours}</strong></td>
                                      <td width="5%">&nbsp;</td>
                                    </tr>
                                  );
                                })
                                }
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              );
            }
            )
            }
          </tbody>
        </table>
      </div>
    );
  }
  render() {

    return (
      <div>
        {this.state.open ?
          <AuthorizationModal
            authId={this.state.authId}
            InsuranceCompanyList={this.props.patient_insurance && this.props.patient_insurance.data ? this.props.patient_insurance.data : [] }
            closeDialog={this.handleClose}
            patientId={this.state.patientId} />
          : null
        }
        <h2 className="page_title">Client Authorizations</h2>
        <PatientInfo patientId={this.state.patientId} />
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              {this.props.addPermission ?
                <CommonButton label="Add Authorization" primary={true} onTouchTap={this.handleOpen} />
                : null
              }
            </div>
            <div className="panel_title mt20">
              <h3>Insurance Authorizations</h3>
              <i className="flaticon flaticon-medical"></i>
            </div>
            <div className="row">
              <div className="col-sm-12 mt-20">
                {this.state.authorizations && this.state.authorizations.length > 0 ?
                  this.renderExpiredData(false)
                  : <div className="familydl text-center no-record">No record found.</div> }
              </div>
            </div>
            <div className="panel_title">
              <h3>Expired Authorizations</h3>
              <i className="flaticon flaticon-medical-1"></i>
            </div>
            <div className="row">
              <div className="col-sm-12 mt-20">
                {this.state.authorizations && this.state.authorizations.length > 0 ?
                  this.renderExpiredData(true)
                  : <div className="familydl text-center no-record">No record found.</div> }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


Authorization = reduxForm({
  form: 'AuthorizationForm',
  enableReinitialize: true,
})(Authorization);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLIENT_AUTHORIZATION_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_AUTHORIZATION_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_AUTHORIZATION_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_AUTHORIZATION_LIST_DELETE')[0].permission : false;

  // End For Role Permission
  return {
    authorizationList: state.patient.authorizationList,
    saved_patientAuthorization: state.patient.saved_patientAuthorization,
    deleted_patientAuthorization: state.patient.deleted_patientAuthorization,
    patient_insurance: state.patient.patientInsuranceList,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}

export default connect(mapStateToProps, { getPatientAuthorizationByID, deletePatientAuthorizationData, getPatientInsuranceForAuthorizationById, UpdatePatientAuthorizationData })(Authorization);



// WEBPACK FOOTER //
// ./src/modules/patients/components/authorization/authorization.js